export default "__VITE_ASSET__DF9C$LyQ__"